'use strict';

/**
 * The client side debug helper
 *
 * @memberof HashBrown.Client.Service
 */
class DebugService extends require('Common/Service/DebugService') {
}

module.exports = DebugService;
